module.exports = __webpack_public_path__ + "static/project-covid19-b92c2e8c67679a343690234467283b19.png";